<template>
    <modal title='Управление отчётами' v-model='showModal' @close='$emit("close")' :backdrop='false' width='800px'>
        <div slot="modal-body" class="modal-body">
            <table v-if='sortedReports.length' class='reports_table'>
                <thead>
                    <tr>
                        <th>Название</th>
                        <th>Актуальность</th>
                        <th>Приоритет</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for='report in sortedReports' :key='report.id'>
                        <td v-text='report.name'/>
                        <td><input type='checkbox' v-model='report.is_actual' @change='changeReport(report.id, $event.target.checked, 0)'/></td>
                        <td>
                            <span class='priority_control plus' @click='changeReport(report.id, report.is_actual, -1)'></span> 
                            <span class='priority_control minus' @click='changeReport(report.id, report.is_actual, 1)'></span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div slot="modal-footer" class="modal-footer">
            <button type="button" class="btn btn-primary" @click='saveReports'>Сохранить</button>
            <button type="button" class="btn btn-secondary" @click='$emit("close")'>Закрыть</button>
        </div>
    </modal>
</template>

<script>
import {DB} from '../constants'
import { modal } from 'vue-strap'

const GET_SYS_REPORTS = 'get_sys_reports.php'
const UPDATE_JSON = 'update_json.php'

export default {
    data () {
        return {
            reports: [],
            showModal: false
        }
    },
    watch: {
        show() {
            this.showModal = this.show
            if(this.show) {
                this.getReports()
            }
        }
    },
    components: {
        modal
    },
    props: {
        show: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        sortedReports() {
            if(this.reports && this.reports.length)
                return this.reports.sort((a,b) => a.priority - b.priority)
            else
                return []
        }
    },
    methods: {
        getReports() {
            fetch(DB + GET_SYS_REPORTS, {
					credentials: 'include'
				})
				.then(res => res.json())
				.then(res => {
					this.reports = res
                    if(this.reports && this.reports.length)
                        this.reports = this.reports.map(e => {
                            const temp = e
                            temp.is_actual = temp.is_actual == 't'
                            return temp
                        })
				})
				.catch(err => console.log(err))
        },
        changeReport(id, actual, priority) {
            const clone = JSON.parse(JSON.stringify(this.reports))
            for(let report in clone) {
                if(clone[report].id == id) {
                    clone[report].is_actual = actual
                    const oldPriority = Number(clone[report].priority)
                    const newPriority = oldPriority + priority
                    if(newPriority > 0 && newPriority < (clone.length + 1)) {
                        for(let report_2 in clone) {
                            if(clone[report_2].priority == newPriority) {
                                clone[report_2].priority = oldPriority
                                clone[report].priority = newPriority
                            }
                        }
                    }
                }
            }
            this.reports = JSON.parse(JSON.stringify(clone))
        },
        saveReports() {
            //console.warn(JSON.stringify(this.reports))
            const res = []
            for(let report of this.reports) {
                res.push({})
                res[res.length - 1].tab_id = 5
                res[res.length - 1].f_v = {
                    'f_c': report.id,
                    'f_123': report.is_actual,
                    'f_124': Number(report.priority)
                }
            }
            const data = JSON.stringify(res)
            //console.warn(data)

            let form = new FormData()
			form.append('json', data)

            fetch(DB + UPDATE_JSON, {
                credentials: 'include',
                method: 'post',
                body: form
            })
            .then(result => result.json())
            .then(result => {
                if(result[0].code === '0')
					alert('Отчёты сохранены')
            })
        }
    },
    mounted() {

    }
}
</script>

<style scoped>
.reports_table {
    width: 100%;
}

.priority_control {
    display: inline-block;
    vertical-align: middle;
    line-height: normal;
    width: 20px;
    height: 20px;
    margin-left: 5px;
    margin-right: 5px;
}

.priority_control:hover {
    opacity: 0.6;
    cursor: pointer;
}

.plus {
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAYdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjEuNWRHWFIAAAB/SURBVDhP7ZIxCoAwDEWzObmIx/EAHqW39hiCCDW/NJNRY9LBwQ+vSUP7oFDKOTdFHUZQhxHUYQRrZmavNZzErMxSK/bu4PLG4C0C9i6pJnNL72SCWWqRCY/SNzLhUuqRCSfpxOBLaIet4D48ZdEOeKGR6dE0yIClK+2fj4ToAD6rWWuWS8bCAAAAAElFTkSuQmCC');
            
}

.minus {
    background:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAYdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjEuNWRHWFIAAAB/SURBVDhP7ZK7DYAwDAXTUdEgxmEARmFrxkBCSMYPYhpMfnbJSYdRFF+V8ONCF6cbI9vfv2YGfCaWHL1AdGO1C6ViH52Hhd1Z7XJO7GH/RUv0MybURLMxoSRaHBNS0eqYoEWbYwKW8STWOE0xYWaPONMQkavqoUX10KJ62C6FE+KNWWtJRQlQAAAAAElFTkSuQmCC');
}
</style>


// WEBPACK FOOTER //
// EditReportsModal.vue?218cc520